import { useEffect } from "react";
import { navigate, useLocation } from "../lib/router";
import { useSession } from "../lib/session";
import { SignInPanel } from "../components/SignInPanel";

const safeNext = (n: string | null) => (n && /^\/[^/]/.test(n) && !n.startsWith("/signin") ? n : "/");

export default function SignIn() {
  const { search } = useLocation();
  const { me } = useSession();
  const next = safeNext(search.get("next"));
  useEffect(() => {
    if (me?.user) navigate(next, { replace: true });
  }, [me?.user, next]);
  return (
    <div className="page narrow">
      <h1>Sign in</h1>
      <p className="lead">Save lessons and adaptations, keep class profiles, and email lessons to yourself. Free.</p>
      <SignInPanel next={next} onDone={() => navigate(next, { replace: true })} />
    </div>
  );
}
